/**
 * PharmacyAuth Repository Interface
 * 약국 인증 관리 데이터 레이어의 추상화 인터페이스
 */
export class IPharmacyAuthRepository {
  /**
   * 비밀번호 설정
   * @param {Object} data - 비밀번호 설정 데이터
   * @param {string} data.business_registration_number - 사업자등록번호
   * @param {string} data.password - 비밀번호
   * @param {string} data.password_confirm - 비밀번호 확인
   * @returns {Promise<BaseResponse<any>>}
   */
  async setPassword(data) {
    throw new Error('Method must be implemented');
  }

  /**
   * 로그인
   * @param {Object} data - 로그인 데이터
   * @param {string} data.business_registration_number - 사업자등록번호
   * @param {string} data.password - 비밀번호
   * @returns {Promise<BaseResponse<any>>}
   */
  async login(data) {
    throw new Error('Method must be implemented');
  }

  /**
   * 토큰 갱신
   * @param {Object} data - 토큰 갱신 데이터
   * @param {string} data.refresh_token - 리프레시 토큰
   * @returns {Promise<BaseResponse<any>>}
   */
  async refreshToken(data) {
    throw new Error('Method must be implemented');
  }

  /**
   * 로그아웃
   * @param {Object} data - 로그아웃 데이터
   * @param {string} data.refresh_token - 리프레시 토큰
   * @returns {Promise<BaseResponse<any>>}
   */
  async logout(data) {
    throw new Error('Method must be implemented');
  }
}
